export enum WasteManagementReportViewModalType {
	CREATE_GENERATOR_REPORT = 'CREATE_GENERATOR_REPORT',
	CREATE_CYCLOTRON_PRODUCT_REPORT = 'CREATE_CYCLOTRON_PRODUCT_REPORT',
	EDIT_GENERATOR_REPORT = 'EDIT_GENERATOR_REPORT',
	EDIT_CYCLOTRON_PRODUCT_REPORT = 'EDIT_CYCLOTRON_PRODUCT_REPORT',
	EDIT = 'EDIT',
	DELETE = 'DELETE'
}
